// extracted by mini-css-extract-plugin
export default {"label":"CheckWrapper_label__q7eOJ","container":"CheckWrapper_container__pwoWz"};